export function getRolNameById(id) {
  switch (id) {
    case 1:
      return 'Móvil';
    case 2:
      return 'Administrador';
    case 3:
      return 'Captura';
    case 4:
      return 'Consulta';
    case 5:
      return 'Validador';
    case 6:
      return 'Móvil - Web';
    case 7:
      return 'Representante de Finanzas Junta Local';
    case 8:
      return 'Representante de Finanzas Oficina Central';
    default:
      return 'N/A';
  }
}

/**
 * Regresa un objeto JSON:
 *          { "idEstado": #,
 *          "nombreEstado": "XXXX"}
 * que coincida con el id pasado como parámetro
 * @param {*} arrOfEdos []
 * @param {*} id Number
 * @returns Objeto estado
 */
export function getEstadoObjById(arrOfEdos, id) {
  let edo = null;
  for (let i = 0; i < arrOfEdos?.length; i += 1) {
    if (arrOfEdos[i]?.idEstado === id) {
      edo = arrOfEdos[i];
    }
  }
  return edo;
}
